import { useState, useEffect, useCallback } from 'react'
import { CardSaleChannel } from './cardSalesChannels'
import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { SalesPeaksGraphic } from './salesPeaksGraphic'
import { api } from '../../../../../services/api'
import { toast } from 'react-toastify'
import { useAuth } from '../../../../../context/AuthContext'

import { Container, Card, Title, ContainerCardsSalesChannels } from './style'


export function SalesChannelsAndSalesPeaks () {
    const [forceLoading, setForceLoading] = useState(false)

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const [isSalesChannelsLoading, setIsSalesChannelsLoading] = useState(true)
    const [salesChannelsData, setSalesChannelsData] = useState([])
    const [gaugeAnimation, setGaugeAnimation] = useState(false)
    let currentSalesChannelsLength = listSalesChannelsId.filter(idChannel => {
        return salesChannelsData.some(saleChannel => saleChannel.id === idChannel)
    })
    
    const { signOut } = useAuth()

    useEffect(() => {
        let resizeThrottleTimeout;
        let skip = false;
        const resizeCb = () => {
          if (skip) {
            return;
          }
    
          setForceLoading(true);
          skip = true;
          resizeThrottleTimeout = setTimeout(() => {
            setForceLoading(false);
            skip = false;
          }, 100);
        };
        window.addEventListener('resize', resizeCb);
    
        return () => {
          clearTimeout(resizeThrottleTimeout);
        }
      }, [setForceLoading]);


    const fetchData = useCallback(async () => {
        setIsSalesChannelsLoading(true)
        setGaugeAnimation(false)
        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter
        }

   
        try{
            await api.post('/getSalesChannels' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => {
                ///console.log(response.data)
                setSalesChannelsData(response.data)
            })
            setIsSalesChannelsLoading(false)
            setGaugeAnimation(true)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [signOut, endDate, startDate, listBusinessToFilter])

    
    useEffect(() =>{
        if(startDate !== '' && endDate !== '')
            fetchData()

        return () => {
            setSalesChannelsData([])
        }

    }, [fetchData, endDate, startDate])

    
    
    return(
        <Container>
            
            <Card>
                <Title>Canais de Venda</Title>
                <ContainerCardsSalesChannels>

                    {
                        isSalesChannelsLoading 
                            ? <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/> 
                            :
                            salesChannelsData.length > 0 
                                ? salesChannelsData.map(saleChannel => (
                                        <CardSaleChannel 
                                            key={saleChannel.id}
                                            typeSale={saleChannel.description}
                                            totalValue={saleChannel.value}
                                            percentage={saleChannel.percent / 100}
                                            quantity={saleChannel.qtd}
                                            ticket={saleChannel.avg}
                                            id={saleChannel.id}
                                            currentSalesChannelsLength={currentSalesChannelsLength}
                                            gaugeAnimation={gaugeAnimation}
                                        />
                                    ))
                                : <p>Nenhuma informação</p>
                    }
                   
                </ContainerCardsSalesChannels>
            </Card>

            <Card>
                <Title>Picos de Venda</Title>
                {forceLoading 
                    ? <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/>
                    : <SalesPeaksGraphic />
                }
            </Card>

        </Container>
    )
}